import styled from '@emotion/styled'

export default styled.div`
  height: auto;
  min-height: 100vh;
`
